/**
 * MaX branding — chart / inline color helpers for dashboards and reports.
 * Brand chrome is neutral (charcoal); use semantic greens only where meaning is success / positive.
 */

export const BRAND_INK = "#0a0a0a";
export const BRAND_CHARCOAL = "#18181b";

/** Primary semantic green (aligned with themes.css --status-success-text on light UI). */
export const SEMANTIC_SUCCESS = "var(--accent-primary)";

/** Brighter green for contrast on dark backgrounds or dense charts. */
export const SEMANTIC_SUCCESS_MID = "var(--accent-primary)";
export const SEMANTIC_SUCCESS_SOFT = "var(--accent-primary)";

/** Multi-series charts: diverse hues; third slot is brand charcoal instead of green. */
export const CHART_PALETTE = [
  "#6366f1",
  "#0ea5e9",
  BRAND_CHARCOAL,
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
];
